import Component from "@tunnel-components/@sharded/@widgets/slider/component";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { connect } from "react-redux";
import * as Utils from "@Cyclope-Utils/index";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onMouseEnter
 * @name onMouseLeave
 * @name
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     */
    this.state = {
      item: props.item,
      Cart: props.Cart,
      position: 0,
      parent: null,
      childrenWidth: props.widthCart + 15, // 395
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onNext = this.onNext.bind(this);
    this.onPrevious = this.onPrevious.bind(this);
  }
  /**
   * @method onPrevious
   * @param { any }    event
   * @infos "https://reactjs.org"
   */
  public onPrevious = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    //
    if (this.state.position > 0) {
      // avoid slide left beyond the first item
      {
        /** Empêcher la mutation du state */
      }
      this.setState((prevState: any): any => ({
        position: prevState.position - 1,
        parent: ReactDOM.findDOMNode(this),
      })); //
      // translate items
    }
  };
  /**
   * @method onNext
   * @param { any }    event
   * @infos "https://reactjs.org"
   */
  public onNext = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     *
     * @param parent
     */
    const hiddenItems = (parent: any): number => {
      let hiddenItem: number = 0;

      if (parent !== null) {
        const items = this.getCount(parent, false);
        hiddenItem =
          items - Math.ceil(parent.offsetWidth / this.state.childrenWidth);
      }
      return hiddenItem;
    };

    if (
      this.state.position >= 0 &&
      this.state.position < hiddenItems(ReactDOM.findDOMNode(this))
    ) {
      // avoid slide right beyond the last item
      {
        /** Empêcher la mutation du state */
      }
      this.setState((prevState: any): any => ({
        position: prevState.position + 1,
        parent: ReactDOM.findDOMNode(this),
      })); //
      // translate items
    }
  };
  /**
   * @method translateX
   * @infos "https://reactjs.org"
   */
  public translateX = (position: number, parent: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    // const slide: any = document.getElementById("slide");

    if (parent !== null) {
      if (this.state.position >= 0) {
        parent.childNodes[1].style.left =
          this.state.position * -this.state.childrenWidth + "px";
        parent.childNodes[1].style.transition = "left 2s ease";
        parent.childNodes[1].WebkitTransition = "left 2s ease";
      }
    }
  };
  /**
   * @method getCount
   * @infos "https://reactjs.org"    //  À refaire
   */
  public getCount = (parent: any, getChildrensChildren: boolean): number => {
    // count no of items
    let relevantChildren: number = 0;

    if (parent !== null) {
      const children = parent.childNodes[1].children.length;

      for (let i = 0; i < children; i++) {
        if (parent.childNodes[1].nodeType !== 3) {
          if (getChildrensChildren) {
            relevantChildren += this.getCount(parent.childNodes[i], true);
          }

          relevantChildren++;
        }
      }
    }

    return relevantChildren;
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.item !== this.props.item) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        item: Utils.transformObjectToArray(nextProps.item),
      }));
    }
    {
      /** Comparaison */
    }
    if (nextProps.Cart !== this.props.Cart) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ Cart: nextProps.Cart }));
    }
    if (nextProps.childrenWidth !== this.props.childrenWidth) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        childrenWidth: nextProps.childrenWidth,
      }));
    }
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** Comparaison */
    }
    if (prevState.position !== this.state.position) {
      this.translateX(this.state.position, this.state.parent);
    }
    if (prevState.item !== this.state.item) {
      if (this.state.item !== undefined) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          itemlength: this.state.item.length,
        }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        {...this.props}
        {...this.state}
        onPrevious={this.onPrevious}
        onNext={this.onNext}
      />
    );
  }
}

{
  /** exporter le HOC : connect */
}
export default connect(null, {})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/slider/container.tsx